import {isDevMode, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from "@angular/forms";

import {TranslateModule} from "@ngx-translate/core";

import {HttpProgressInterceptor} from "@commons/services/http.interceptor/http-progress-interceptor.service";

import {ShowTimeoutModalService} from "@shared/services/show-timeout-modal.service";
import {ShowErrorModalService} from "@shared/services/show-error-modal.service";
import {AppErrorHandler} from "@shared/error-handler";
import {SharedModule} from "@shared/shared.module";

import {MainRouteComponent} from './routes/main-route/main-route.component';
import {VehiclesListComponent} from './routes/main-route/components/vehicles-list/vehicles-list.component';
import {VehiclesFilterComponent} from './routes/main-route/components/vehicles-filter/vehicles-filter.component';
import {VehicleItemComponent} from './routes/main-route/components/vehicles-list/components/vehicle-item/vehicle-item.component';
import {
  VehicleHandoversListComponent
} from './routes/main-route/components/vehicle-handovers-list/vehicle-handovers-list.component';
import {
  HandoversListItemComponent
} from './routes/main-route/components/vehicle-handovers-list/components/handovers-list-item/handovers-list-item.component';
import {
  RightPanelComponent
} from './routes/main-route/components/right-panel/right-panel.component';
import {WorkerStatementComponent} from './routes/main-route/components/worker-statment/worker-statement.component';
import { HandoverComponent } from './routes/main-route/components/handover/handover.component';
import { HandoverSectionComponent } from './routes/main-route/components/handover/components/handover-section/handover-section.component';
import { HandoverDamagesComponent } from './routes/main-route/components/handover/components/handover-damages/handover-damages.component';
import { HandoverGeneralComponent } from './routes/main-route/components/handover/components/handover-general/handover-general.component';
import { HandoverCommentsComponent } from './routes/main-route/components/handover/components/handover-comments/handover-comments.component';
import { HandoverEquipmentComponent } from './routes/main-route/components/handover/components/handover-equipment/handover-equipment.component';
import { HandoverHeaderComponent } from './routes/main-route/components/handover/components/handover-header/handover-header.component';
import { HandoverTopLabelComponent } from './routes/main-route/components/handover/components/handover-top-label/handover-top-label.component';
import { HandoverStatementComponent } from './routes/main-route/components/handover/components/handover-statement/handover-statement.component';
import { HandoverSignatureComponent } from './routes/main-route/components/handover/components/handover-signature/handover-signature.component';
import { HandoverBottomLabelComponent } from './routes/main-route/components/handover/components/handover-bottom-label/handover-bottom-label.component';
import { HandoverMenuComponent } from './routes/main-route/components/handover/components/handover-menu/handover-menu.component';
import { HandoverLimitedAccessModalComponent } from './routes/main-route/components/vehicle-handovers-list/components/handover-limited-access-modal/handover-limited-access-modal.component';
import { HandoverAddComponent } from './routes/main-route/components/handover-add/handover-add.component';

@NgModule({
  declarations: [
    MainRouteComponent,
    VehiclesListComponent,
    VehiclesFilterComponent,
    VehicleItemComponent,
    VehicleHandoversListComponent,
    HandoversListItemComponent,
    RightPanelComponent,
    WorkerStatementComponent,
    HandoverComponent,
    HandoverSectionComponent,
    HandoverDamagesComponent,
    HandoverGeneralComponent,
    HandoverCommentsComponent,
    HandoverEquipmentComponent,
    HandoverHeaderComponent,
    HandoverTopLabelComponent,
    HandoverStatementComponent,
    HandoverSignatureComponent,
    HandoverBottomLabelComponent,
    HandoverMenuComponent,
    HandoverLimitedAccessModalComponent,
    HandoverAddComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule,
    ReactiveFormsModule
  ],
  exports: [
    MainRouteComponent
  ]
})
export class HandoverModule {
  constructor(
    private showTimeoutModalService: ShowTimeoutModalService,
    private showErrorModalService: ShowErrorModalService
  ) {
    this.subscribeToError();
    this.subscribeToHttpProgressInterceptorEvents();
  }

  private subscribeToError() {
    AppErrorHandler.$onError.subscribe(error => this.showErrorModalService.showModal(error));
  }

  private subscribeToHttpProgressInterceptorEvents() {
    HttpProgressInterceptor.$errorSubject.subscribe(() => this.showTimeoutModalService.showModal());
    HttpProgressInterceptor.$timeoutSubject.subscribe(() => this.showTimeoutModalService.showModal());
  }
}
